import { withStyles } from "@material-ui/core";
import { InfoOutlined } from '@material-ui/icons';

export const InfoRoundIcon = withStyles(theme => ({
  root: {
    color: "#1FB6AD"
  }
}))(InfoOutlined);